import { useEffect, useState } from 'react'

import { getRentalPortalApplicantsFieldOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import {
  APPLICANTS_LISTING_FIELD_NAME,
  APPLICANTS_LISTING_OPTIONS_SIZE,
} from '../../RentalPortalApplicants.constants'

export function useRentalPortalApplicantsListingOptions() {
  const [listingOptions, setListingOptions] = useState(EMPTY_LIST)

  useEffect(() => {
    getRentalPortalApplicantsFieldOptions({
      fieldName: APPLICANTS_LISTING_FIELD_NAME,
      size: APPLICANTS_LISTING_OPTIONS_SIZE,
    })
      .then(({ data }) => {
        setListingOptions(data.items)
      })
      .catch(() => {
        setListingOptions(EMPTY_LIST)
      })
  }, [])

  return listingOptions
}
